import { __css, Text } from '@fluentui/react-components';

const useStyles = __css({"root":{"mc9l5x":"f22iagw","Brf1p80":"f4d9j23","Byoj8tv":0,"uwmqm3":0,"z189sj":0,"z8tnut":0,"B0ocmuz":"fop8ug2"}});

export const FinishedPage = () => {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <Text size={500}>Session finished.</Text>
    </div>
  );
};


import "/usr/local/jenkins/workspace/BI_bi-frontend_2.2.3/src/components/FinishedPage.griffel.css";